exports = module.exports = require("./../../node_modules/.npminstall/css-loader/0.21.0/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".checkbox>label:not(:first-child) {\n  margin-left: 15px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/css-loader/0.21.0/css-loader!./~/.npminstall/vue-loader/7.1.7/vue-loader/lib/style-rewriter.js?id=_v-cdbe891c&file=formGroupDocs.vue!./~/.npminstall/vue-loader/7.1.7/vue-loader/lib/selector.js?type=style&index=0!./docs/example/formGroupDocs.vue
// module id = 254
// module chunks = 0